import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useRouter } from './use-router';
import {
  handleNavigateAtTarget,
  backNavigate,
} from 'src/utils/navigation-utils';

// Please add source in useEffect(() => { return <This function> });
const backButtonPressed = (
  onCallback = () => {
    window.history.back();
  },
) => {
  const handlePopState = (event) => {
    if (event.state) {
      // showLog('Back button pressed!');
      onCallback();

      // if (window.confirm("Do you want to go back to the previous page?")) {
      //   window.history.back();
      // } else {
      //   // Prevent back navigation
      //   window.history.pushState(null, null, window.location.pathname);
      // }
    }
  };

  // Add the event listener when the component mounts
  window.addEventListener('popstate', handlePopState);

  // Push initial state once when the component loads
  window.history.pushState({ page: 1 }, '', window.location.pathname);

  // Clean up the event listener when the component unmounts
  return () => {
    window.removeEventListener('popstate', handlePopState);
  };
};

export const useForm = () => {
  const router = useRouter();
  const { param } = useParams();

  const { backValue, targetValue } = useMemo(() => {
    if (!param) return { backValue: null, targetValue: null };
    const decoded = handleNavigateAtTarget(param);
    return {
      backValue: decoded?.bVal ?? null,
      targetValue: decoded?.vals ?? null,
    };
  }, [param]);

  const handleNavigate = () => {
    backNavigate(router, backValue);
  };

  useEffect(() => {
    return backButtonPressed(() => {
      backNavigate(router, backValue);
    });
  }, [backValue]);

  return {
    handleNavigate,
    itemNavigate: targetValue,
  };
};
